import { appealWorkspacePath } from '../../utils/appealWorkspace';

export const buildAppealQueueItem = appeal => {
  const bucketId = appeal.queueBucketId || 'pending-decision';
  const status = ['file-complete-processing-due', 'in-assessment'].includes(bucketId) ? 'Ready for reassessment' : bucketId === 'pending-review' ? 'Awaiting review' : appeal.queueWork?.some(work => work.status === 'unassigned') ? 'Caseworker needed' : 'Pending decision';
  return {
    id: `appeal-${appeal.id}-${bucketId}`, type: 'AppealRequest', bucketId,
    appealWork: appeal.queueWork || [],
    title: appeal.participantName || appeal.caseNumber || 'Appeal request',
    applicant: appeal.participantName || null,
    trackingId: appeal.caseNumber || `Appeal ${appeal.id}`,
    titleSecondaryText: `Appeal request · ${status}`,
    case_id: appeal.caseId, application_id: appeal.originalDecision.applicationId || null,
    approvalRequestType: 'appeal', approvalRequestTypeLabel: 'Appeal request',
    status, summary: appeal.request.requestedChange, nextAction: ['file-complete-processing-due', 'in-assessment'].includes(bucketId) ? 'Reassess' : 'Review appeal',
    owner: '—',
    region: appeal.province || null, address_province: appeal.province || null,
    assessment_esdc_eligibility: appeal.assessmentEligibility || null,
    submittedAt: appeal.createdAt, dueDate: null,
    workspacePath: appealWorkspacePath(appeal),
  };
};

// Replace the ordinary task for this exact subject, not other work on the case.
export const mergeAppealQueueItems = (regular, appeals) => [...regular.filter(item => !appeals.some(appeal =>
  appeal.bucketId === item.bucketId && String(appeal.case_id) === String(item.case_id) &&
  appeal.appealWork.some(work => work.kind === 'application_assessment'
    ? !item.interventionId && !item.intervention_id && String(work.applicationId) === String(item.application_id)
    : work.id && String(work.id) === String(item.interventionId || item.intervention_id))
)), ...appeals];

export const mergeAppealQueueCounts = (counts, regular, appeals) => {
  const merged = mergeAppealQueueItems(regular, appeals);
  const result = { ...counts };
  for (const bucket of new Set(appeals.map(item => item.bucketId))) {
    const before = regular.filter(item => item.bucketId === bucket).length;
    const after = merged.filter(item => item.bucketId === bucket).length;
    result[bucket] = (Number.isFinite(counts[bucket]) ? counts[bucket] : before) + after - before;
  }
  return result;
};
